export const ApplicationVersion = 'retailer-web:1.1.1.1';
